module.exports = __webpack_public_path__ + "static/fonts/gilroy-medium.9e12d60.otf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/gilroy-medium.otf
// module id = j6R1
// module chunks = 28